import { get, post } from '@/utils/request'

// 消息模板列表 https://www.showdoc.com.cn/1281067606385943/6897367278597320
export const messageTemplateList = get('/message/template/list')

// 模板编辑 https://www.showdoc.com.cn/1281067606385943/6897417127088211
export const messageTemplateSave = post('/message/template/save')

// 启用停用状态变更 https://www.showdoc.com.cn/1281067606385943/6897507501404063
export const messageTemplateUsed = post('/message/template/used')

// 保存通知消息 https://www.showdoc.com.cn/1281067606385943/6898697395776400
export const messageNoticeSave = post('/message/notice/save')

// 通知消息列表 https://www.showdoc.com.cn/1281067606385943/6898713516743951
export const messageNoticeList = get('/message/notice/list')

export const errorLogList = get('/message/errorLogPage')

export const delAllErrorLog = post('/message/delAllErrorLog')

// 通知消息详情 https://www.showdoc.com.cn/1281067606385943/6898714910804145
export const messageNoticeView = get('/message/notice/view')

// 停止通知消息 https://www.showdoc.com.cn/1281067606385943/6898716746974452
export const messageNoticeStop = post('/message/notice/stop')

// 删除通知消息 https://www.showdoc.com.cn/1281067606385943/6898717339391171
export const messageNoticeDel = post('/message/notice/del')

// 首页通知消息列表 https://www.showdoc.com.cn/1281067606385943/6898716531029001
export const messageUserNoticeList = get('/message/user/notice/list')

// 用户消息列表（未读、已读） https://www.showdoc.com.cn/1281067606385943/7133807960826219
export const messageUserMessageList = get('/message/user/message/list')

// 标记用户消息为已读 https://www.showdoc.com.cn/1281067606385943/7133839009467810
export const messageUserMessageRead = post('/message/user/message/read')

// 删除用户消息 https://www.showdoc.com.cn/1281067606385943/7133839650274689
export const messageUserMessageDel = post('/message/user/message/del')

